import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useState, useCallback, useEffect } from "react";
import { useInfo, useUpdateInfo } from "../../hooks/useInfo";
import RichTextEditor from "../RichTextEditor";
import toast from "react-hot-toast";

const AboutUsTab = () => {
  const { data: info, isLoading } = useInfo();
  const updateInfoMutation = useUpdateInfo();
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (info?.description !== undefined) {
      setDescription(info.description);
    }
  }, [info?.description]);

  const handleSubmit = useCallback(async () => {
    try {
      await updateInfoMutation.mutateAsync({ ...info, description });
      toast.success("About Us updated successfully");
    } catch {
      toast.error("Failed to update About Us");
    }
  }, [description, info, updateInfoMutation]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress sx={{ color: "rgba(255,255,255,0.35)" }} />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Typography
        variant="overline"
        sx={{ color: "rgba(255,255,255,0.4)", letterSpacing: "0.2em", fontSize: "0.68rem" }}
      >
        About Us
      </Typography>

      <RichTextEditor
        label="About Us"
        value={description}
        onChange={setDescription}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          onClick={handleSubmit}
          variant="outlined"
          disabled={updateInfoMutation.isPending}
          sx={{
            borderColor: "rgba(255,255,255,0.22)",
            color: "rgba(255,255,255,0.8)",
            px: 4,
            fontWeight: 600,
            fontSize: "0.75rem",
            letterSpacing: "0.12em",
            "&:hover": { borderColor: "white", backgroundColor: "rgba(255,255,255,0.06)", color: "white" },
            "&.Mui-disabled": { color: "rgba(255,255,255,0.2)", borderColor: "rgba(255,255,255,0.08)" },
          }}
        >
          {updateInfoMutation.isPending ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default AboutUsTab;
